import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { WorkOrdersRoutes } from '../../../routes';

export const WorkOrdersLayout = () => <SwitchRoute routes={WorkOrdersRoutes} />;
